
import TreeViewTopNode from '../TreeView/TreeViewTopNode.vue'
import PrescalesTable from '../PrescalesTable.vue'

import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'

@Component({
  computed: {
    ...mapGetters({
      getTreeRefsMap: 'getTreeRefsMap',
      getConfigNodesMap: 'getConfigNodesMap',
      getOpenNodeIds: 'getOpenNodeIds',
      getForcedActiveNodeId: 'getForcedActiveNodeId',
      getForcedActiveNodeType: 'getForcedActiveNodeType',
      getDarkMode: 'getDarkMode',
      getIDCounter: 'getIDCounter',
      getTopLevelNodeNameReferenceIDsMap: 'getTopLevelNodeNameReferenceIDsMap',
      getTopLevelDatasetNameToIdMap: 'getTopLevelDatasetNameToIdMap',
    }),
  },
  methods: {
    ...mapActions({
      setSnackBarText: 'setSnackBarText',
      setSelectedNodeViaID: 'setSelectedNodeViaID',
    }),
  },
  components: {
    TreeViewTopNode,
    PrescalesTable,
  },
})
export default class TreeViewTab extends Vue {
  @Prop(String) treeType!: string
  @Prop(String) treeRef!: String
  @Prop(Array) items!: Array<Object>
  @Prop(Object) iconTypes!: Object
  @Prop(Object) iconColors!: Object
  @Prop(String) search!: String
  @Prop(Boolean) searchDeep!: Boolean

  @Watch('getForcedActiveNodeType')
  // eslint-disable-next-line no-unused-vars
  onForcedActiveTypeChanged(val: any, oldVal: any) {
    if (val == this.treeType) {
      this.$nextTick().then(() => {
        let refName = 'lazy_' + this.getForcedActiveNodeId
        //@ts-ignore
        this.$refs[refName][0].$el.scrollIntoView()
      })
    }
  }

  //Vuex getters
  private getTreeRefsMap!: Object
  private getConfigNodesMap!: Object
  private getTopLevelDatasetNameToIdMap!: Object
  private getForcedActiveNodeType!: string
  private getForcedActiveNodeId!: number

  //Vuex actions
  private setSnackBarText!: (payload: {
    snackBarText: string
    snackBarColor: string
  }) => Promise<any>
  private setSelectedNodeViaID!: (payload: {
    selectedNodeId: number
    forceOpenNode: boolean
  }) => Promise<any>

  //methods
  public displayLazy(item: Object): string {
    if (this.search != null && this.search != '') {
      if (item['name'].indexOf(this.search) > -1) {
        return ''
      } else {
        //deep search?
        if (this.searchDeep)
          if (this.recurseDisplayLazy(item)) {
            return ''
          }
        return 'none'
      }
    } else {
      return ''
    }
  }

  public recurseDisplayLazy(item: Object): boolean {
    if (item['children'] != undefined) {
      for (let i = 0; i < item['children'].length; i++) {
        if (item['children'][i]['name'].indexOf(this.search) > -1) {
          return true //if found return immidiately
        }
      }
      //go in recursion
      for (let i = 0; i < item['children'].length; i++) {
        if (this.recurseDisplayLazy(item['children'][i])) return true
      }
    }
    return false
  }

  public checkIfNodeIsParamType(itemType: string): boolean {
    if (
      itemType.indexOf('cms.') != -1 ||
      itemType == 'string' ||
      itemType == 'int32' ||
      itemType == 'double' ||
      itemType == 'VPSet' ||
      itemType == 'PSet' ||
      itemType == 'untracked.PSet' ||
      itemType == 'untracked.VPSet' ||
      itemType == 'InputTag'
    )
      return true
    else return false
  }

  public checkIfNodeIsString(itemType: string): boolean {
    if (itemType == 'string' || itemType == 'cms.string') return true
    else return false
  }

  async fetchNodeById(itemId: number): Promise<void> {
    //console.log('ITEM ID: ' + itemId)
    //console.log('NODE: ' + JSON.stringify(this.getConfigNodesMap[itemId]))
    if (
      this.getConfigNodesMap[itemId] == undefined ||
      this.checkIfNodeIsParamType(this.getConfigNodesMap[itemId].type) //don't fetch params
    ) {
      if (this.checkIfNodeIsString(this.getConfigNodesMap[itemId].type)) {
        //handle stream to dataset linking - get the ID of the dataset
        let dataSetName = this.getConfigNodesMap[itemId].paremeterJSONValue
        let dataSetID = this.getTopLevelDatasetNameToIdMap[dataSetName]

        console.log('DATASET ID: ' + dataSetID)

        await this.setSelectedNodeViaID({
          selectedNodeId: dataSetID,
          forceOpenNode: true,
        })
      }
      return
    }

    if (this.getConfigNodesMap[itemId].rootNodeId != itemId) {
      itemId = this.getConfigNodesMap[itemId].rootNodeId
      //console.log('ROOT NODE ID: ' + itemId)

      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
    } else
      await this.setSelectedNodeViaID({
        selectedNodeId: itemId,
        forceOpenNode: false,
      })
  }

  rightMouseClicked(value: Object) {
    //console.log(value)
    this.$emit('rightMenuClicked', value)
  }

  created() {
    console.log(this.treeType + ' TAB CREATED')
    //console.log(this.$refs)
    //console.log(this.$root.$refs)
  }

  mounted() {
    console.log(this.treeType + ' TAB MOUNTED')
    if (this.getForcedActiveNodeType == this.treeType) {
      this.$nextTick().then(() => {
        let refName = 'lazy_' + this.getForcedActiveNodeId
        //@ts-ignore
        this.$refs[refName][0].$el.scrollIntoView()
      })
    }
  }

  updated() {
    console.log(this.treeType + 'TAB UPDATED')
    //this.$nextTick().then(() => {})
  }
}
